import MetaDataList from './MetaDataList';

export default MetaDataList;
